module.exports = __webpack_public_path__ + "static/img/5.89b9c48.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/sp/5.png
// module id = Y04A
// module chunks = 0